/**
 * Forme sous laquelle les choix se présentent au répondant.
 *
 * En boutons, ils sont tous sous ses yeux et se désignent d'un geste. En liste déroulante, ils
 * s'effacent derrière un seul champ, qui les découvre au clic : c'est ce qu'il faut quand ils sont
 * trop nombreux pour tenir dans la page. Les valeurs sont celles du discriminant renvoyé par l'API.
 */
export enum CHOICES_DISPLAY {
    BUTTON = 'BUTTON',
    LIST = 'LIST',
}
